"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _authWidget = _interopRequireDefault(require("../auth-widget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function createAuthButton(WrappedComponent) {
  var Wrapper =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Wrapper, _React$Component);

    function Wrapper(props) {
      var _this;

      _classCallCheck(this, Wrapper);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Wrapper).call(this, props));
      _this.onWrappedCompClick = _this.onWrappedCompClick.bind(_assertThisInitialized(_this));
      _this.onResult = _this.onResult.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(Wrapper, [{
      key: "onResult",
      value: function onResult(result) {
        var _this$props = this.props,
            onError = _this$props.onError,
            onSuccess = _this$props.onSuccess;

        if (result.error) {
          onError(result);
        } else {
          onSuccess(result);
        }
      }
    }, {
      key: "onWrappedCompClick",
      value: function onWrappedCompClick() {
        var _this$props2 = this.props,
            onClick = _this$props2.onClick,
            options = _this$props2.options;
        onClick.apply(void 0, arguments);

        _authWidget.default.authenticator(options, this.onResult).launch();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
            options = _this$props3.options,
            onSuccess = _this$props3.onSuccess,
            onError = _this$props3.onError,
            onClick = _this$props3.onClick,
            rest = _objectWithoutProperties(_this$props3, ["options", "onSuccess", "onError", "onClick"]); // Pass the props except config, onSuccess, onError and onClick
        // We pass this.onWrappedCompClick instead of this.props.onClick and
        // handle authenticator stuff in this.onWrappedCompClick


        return _react.default.createElement(WrappedComponent, _extends({}, rest, {
          onClick: this.onWrappedCompClick
        }));
      }
    }]);

    return Wrapper;
  }(_react.default.Component); // Set display name


  var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  Wrapper.displayName = "createAuthButton(".concat(displayName, ")"); // hoist non-react static methods

  (0, _hoistNonReactStatics.default)(Wrapper, WrappedComponent); // set prop type

  Wrapper.propTypes = {
    options: _propTypes.default.shape({
      client_id: _propTypes.default.string.isRequired,
      scope: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      extra_data: _propTypes.default.string,
      oob_loading_delay: _propTypes.default.number
    }).isRequired,
    onSuccess: _propTypes.default.func.isRequired,
    onError: _propTypes.default.func,
    onClick: _propTypes.default.func
  }; // set default props

  Wrapper.defaultProps = {
    onClick: function onClick() {},
    onError: function onError() {}
  };
  return Wrapper;
}

var _default = createAuthButton;
exports.default = _default;